import { useTranslation } from "react-i18next"
import { useParams } from "react-router"
import useSWR from "swr"
import { PullSheetApi } from "../../apis"
import { PageLayout } from "../layout"
import { usePermission } from "../permission"
import { ListState } from "../ui"
import { SupplierShippingCustomerDetailForm } from "./form"

export function SupplierShippingCustomerDetail() {
  const params = useParams()
  const { t } = useTranslation(["delivery", "common"])
  const ORD_PS_DETAIL = usePermission("ORD_PS_DETAIL")

  const { data, error, isLoading, mutate } = useSWR(
    ORD_PS_DETAIL.hasAccess && params.id ? `/pull_sheet/detail/${params.id}` : null,
    async () => await PullSheetApi.get(params.id as string),
    { revalidateOnFocus: false },
  )

  if (ORD_PS_DETAIL.hasAccess && data) {
    return <SupplierShippingCustomerDetailForm action={["detail", data]} reload={() => mutate()} />
  }

  const breadcrumb = [
    { to: "/", label: t("common:breadcrumb.home") },
    { to: "/supplier-shipping", label: t("delivery:breadcrumb.loadingManagement") },
    { label: t("delivery:pullSheet.pullSheet") },
  ]

  let body
  if (!ORD_PS_DETAIL.hasAccess) {
    body = <ListState state="denied" permission="ORD_PS_DETAIL" />
  } else if (error) {
    const status = (error as { statusCode?: number }).statusCode
    body = (
      <ListState
        state="error"
        title={status === 404 ? t("delivery:psDetail.notFound") : undefined}
        description={status === 404 ? t("delivery:psDetail.notFoundText") : undefined}
        errorCode={status}
        onRetry={() => mutate()}
      />
    )
  } else if (isLoading || !data) {
    body = <ListState state="loading" columns={4} rows={6} />
  }

  return (
    <PageLayout title={t("delivery:pullSheet.detailTitle")} subTitle={t("delivery:pullSheet.detailSubTitle")} breadcrumb={breadcrumb}>
      {body}
    </PageLayout>
  )
}
